import * as actoinTypes from './DocumentActionType';

export const getDocumentsRequest = (data) => ({
    type: actoinTypes.GET_DOCUMNETS_REQUEST,
    payload: data,
});
export const getDocumentsSuccess = (data) => ({
    type: actoinTypes.GET_DOCUMNETS_SUCCESS,
    payload: data,
});
export const getDocumentsFailure = (error) => ({
    type: actoinTypes.GET_DOCUMNETS_FAILURE,
    payload: error,
});